export default __webpack_public_path__ + "static/media/microsoft-sign-in.e2f600a8.svg";